import { render } from "./PassFlag.vue?vue&type=template&id=083360cd"
import script from "./PassFlag.vue?vue&type=script&lang=js"
export * from "./PassFlag.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__